import React from 'react';

export type Props = {
  className?: string;

  fill?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};
export const Bag = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 24}
      height={props.height || 24}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d={`M3.91732 10.9095C3.96415 10.3944 4.39601 10 4.91321 10H19.0868C19.604 10 20.0359 
        10.3944 20.0827 10.9095L20.9009 19.9095C20.9541 20.4951 20.493 21 19.905 21H4.09503C3.507 
        21 3.0459 20.4951 3.09914 19.9095L3.91732 10.9095Z`}
        stroke={props.fill || '#0F0A1B'}
        strokeWidth='3'
        strokeLinecap='round'
      />
      <path
        d='M16 13V7C16 4.79086 14.2091 3 12 3V3C9.79086 3 8 4.79086 8 7V13'
        stroke={props.fill || '#0F0A1B'}
        strokeWidth='3'
        strokeLinecap='round'
      />
    </svg>
  );
});

Bag.displayName = 'Bag';
